const required = (value: string) => (value ? undefined : 'Required');
const myanmarPhoneNo = (value: string) =>
  value && !/^09[0-9]+$/.test(value) ? 'Invalid mobile phone number' : undefined;
// tslint:disable-next-line:no-any
const passwordsMatch = (value: string, allValues: any) =>
  value !== allValues.password ? 'Passwords does not match' : undefined;

export {
  required,
  myanmarPhoneNo,
  passwordsMatch,
};



// WEBPACK FOOTER //
// ./src/reduxFormAntd/validations.ts